import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageTitlePatterns  } from '../utils/pageTitles';

const baseTitle = 'ERP El Origen';

export const TitleManager = () => {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname;

        const match = pageTitlePatterns.find(({ pattern }) => pattern.test(path));
        const matchedTitle = match ? match.getTitle(path) : '';

        document.title = matchedTitle ? `${baseTitle} - ${matchedTitle}` : baseTitle;
    }, [location]);

    return null;
};